<template>
    <div class="console">
        <div class="hello">
            <div class="l">
                <img src="https://i.gtimg.cn/club/item/face/img/2/16022_100.gif" alt="">
            </div>
            <div class="r">
                <div class="t">您好管理者！欢迎登录系统。</div>
                <div class="b">您好管理者！欢迎登录系统。</div>
            </div>
        </div>

        
        <div class="condition">
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
                </el-date-picker>
                <!-- <el-input v-model="conditionData.startDate" size="small" placeholder="请输入"></el-input> -->
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
                </el-date-picker>
                <!-- <el-input v-model="conditionData.endDate" size="small" placeholder="请输入"></el-input> -->
            </div>
            
            <div class="btns">
                <el-button type="primary" size="small" @click="QueryPayInfoStati()">查询</el-button>
            </div>
           
            <el-tag type="success" style="margin-left:10px">微信：{{payWX}}</el-tag>
            <el-tag style="margin-left:10px">支付宝：{{payZFB}}</el-tag>
            <el-tag type="info" style="margin-left:10px">ios：{{payIOS}}</el-tag>
            <el-tag type="warning" style="margin-left:10px" @click="changeShenhe">总计：{{total}}</el-tag>
        </div>
        
        
    
        <!-- <el-row>
            <el-col :lg="12" :md="24" :sm="24" :xs="24">
                <div class="echart echart-user">
                    <div class="title">
                        <div class="l">
                            <div class="icon-1">
                                <img src="../../../assets/images/icon18.png" alt="">
                            </div>
                            用户画像
                        </div>
                    </div>

                    <div class="user">
                        <div class="user-title">
                            <div class="user-title-item">
                                <img src="../../../assets/images/icon15.png" alt="">
                            </div>
                            <div class="user-title-item user-title-item2">
                                <img src="../../../assets/images/icon16.png" alt="">
                            </div>
                            <div class="user-title-item user-title-item3">
                                <img src="../../../assets/images/icon17.png" alt="">
                            </div>
                        </div>

                        <div class="user-content">
                            <div class="user-citem" v-for="(item,index) in this.userData.man" :key="index" :style="height" >
                                <div class="user-citem-m"></div>
                            </div>
                            <div class="user-citem" v-for="(item,index) in this.userData.woman" :key="userData.man+index" :style="height">
                                <div class="user-citem-w"></div>
                            </div>
                            <div class="user-citem" v-for="(item,index) in this.userData.unknown" :key="userData.man+userData.woman+index" :style="height">
                                <div class="user-citem-u"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row> -->
        
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'console',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            visitChart:null,
            visitChart2:null,
            orderChart:null,
            authorizationChart:null,
            name:localStorage.getItem('name'),
            tableData:[{
                type:"蜜仆公估",
                caseNumber:"237231",
                caseFinanceNumber:"215",
                projectNumber:"1643",
                projectFinanceNumber:"35",
            },{
                type:"蜜仆",
                caseNumber:"18787",
                caseFinanceNumber:"215",
                projectNumber:"261",
                projectFinanceNumber:"35",
            },{
                type:"资产评估",
                caseNumber:"173",
                caseFinanceNumber:"15",
                projectNumber:"6",
                projectFinanceNumber:"1",
            },{
                type:"快赔(江门)",
                caseNumber:"81846",
                caseFinanceNumber:"215",
                projectNumber:"20",
                projectFinanceNumber:"5",
            }],
            userData:{
                man:50,
                woman:40,
                unknown:10
            },
            height:'',
            conditionData:{
                StartTime:'',
                EndTime:'',
            },
            data:{
                aliTotal: 0,
                iapTotal:0,
                wxTotal: 0
            },

            payWX: 0,
            payZFB: 0,
            payIOS: 0,
        }
    },
    created(){
        

    },
    mounted(){
        
        // this.initVisitChart();
        // this.initVisitChart2();
        // this.initAuthorizationChart();
        this.initOrderChart();
        // let _this = this;
        // window.onresize = function(){
        //     console.log('onresize');
        //     console.log(document.querySelector('.user-citem').style);
        //     _this.height = 'height:'+document.querySelector('.user-citem').style.width+'px';
        //     console.log(_this.height);
        // }
        this.QueryPayInfoStati();
    },
    methods:{
        changeShenhe(){
            if(!localStorage.getItem('mipu_issh')){
                localStorage.setItem('mipu_issh','1')
            }else if(localStorage.getItem('mipu_issh') == '0'){
                localStorage.setItem('mipu_issh','1')
            }else if(localStorage.getItem('mipu_issh') == '1'){
                localStorage.setItem('mipu_issh','0')
            }
        },
        async QueryPayInfoStati(){
            let res = await api.QueryPayInfoStati(this.conditionData);
            console.log(res);
            this.data = res.data.data
            this.total = this.data.totalAmount.toFixed(2)
            this.payWX = this.data.wechatAmount.toFixed(2)
            this.payZFB = this.data.alipayAmount.toFixed(2)
            this.payIOS = this.data.appleAmount.toFixed(2)
           
            

        },
        initVisitChart(){
            let option = {
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    // axisLabel: {
                    //     show: false
                    // }
                },
                grid: {
                    top:'15% ',
                    bottom:'15% ',
                    left: '20% '
                },
                series: [{
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    smooth: true,
                    areaStyle: {},
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 1, 0, 0,
                            [
                                {offset: 0, color: '#13ce66'},
                                {offset: 0.5, color: '#58e7d6'},
                                {offset: 1, color: '#4ac1fe'}
                            ]
                        )
                    },
                }]
            };
            this.$nextTick(()=>{
                
                this.visitChart = this.$echarts.init(this.$refs.visit);
                this.visitChart.clear();
                this.visitChart.setOption(option,true);
                this.visitChart.resize();
            })
        },
        initAuthorizationChart(){
            let option = {
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    type: 'value',
                   
                },
                grid: {
                    top:'15% ',
                    bottom:'15% ',
                    left: '20% '
                },
                series: [{
                    data: [120, 200, 150, 80, 70, 110, 130],
                    type: 'bar',
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#83bff6'},
                                {offset: 0.5, color: '#188df0'},
                                {offset: 1, color: '#188df0'}
                            ]
                        )
                    },
                }]
            };
            this.$nextTick(()=>{
                console.log(this.$refs.authorization);
                console.log(this.$echarts);
                console.log(this.authorizationChart);
                this.authorizationChart = this.$echarts.init(this.$refs.authorization);
                this.authorizationChart.clear();
                this.authorizationChart.setOption(option,true);
                this.authorizationChart.resize();
            })
            
        },
        initVisitChart2(){
            let option = {
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    // axisLabel: {
                    //     show: false
                    // }
                },
                grid: {
                    top:'15% ',
                    bottom:'15% ',
                    left: '20% '
                },
                series: [{
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    smooth: true,
                    areaStyle: {},
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 1, 0, 0,
                            [
                                {offset: 0, color: '#13ce66'},
                                {offset: 0.5, color: '#58e7d6'},
                                {offset: 1, color: '#4ac1fe'}
                            ]
                        )
                    },
                }]
            };
            this.$nextTick(()=>{
                
                this.visitChart2 = this.$echarts.init(this.$refs.visit2);
                this.visitChart2.clear();
                this.visitChart2.setOption(option,true);
                this.visitChart2.resize();
            })
        },
        initOrderChart(){
            const colors = ['#67c23a','#5470C6', '#4ac1fe', '#222222'];
            let option = {
            color: colors,
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'cross'
                }
            },
            grid: {
                right: '20%'
            },
            toolbox: {
                feature: {
                // dataView: { show: true, readOnly: false },
                // restore: { show: true },
                // saveAsImage: { show: true }
                }
            },
            legend: {
                data: ['微信', '支付宝', 'ios','总额']
            },
            xAxis: [
                {
                type: 'category',
                axisTick: {
                    alignWithLabel: true
                },
                // prettier-ignore
                data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                }
            ],
            yAxis: [
                {
                type: 'value',
                name: '金额',
                position: 'right',
                alignTicks: true,
                axisLine: {
                    show: true,
                    lineStyle: {
                    color: colors[0]
                    }
                },
                axisLabel: {
                    formatter: '{value} ￥'
                }
                },
                {
                type: 'value',
                name: '金额',
                position: 'right',
                alignTicks: true,
                offset: 80,
                axisLine: {
                    show: true,
                    lineStyle: {
                    color: colors[1]
                    }
                },
                axisLabel: {
                    formatter: '{value} ￥'
                }
                },
                {
                type: 'value',
                name: '金额',
                position: 'left',
                alignTicks: true,
                axisLine: {
                    show: true,
                    lineStyle: {
                    color: colors[2]
                    }
                },
                axisLabel: {
                    formatter: '{value} ￥'
                }
                }
            ],
            series: [
                {
                name: '微信',
                type: 'bar',
                data: [
                    2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
                ]
                },
                {
                name: '支付宝',
                type: 'bar',
                yAxisIndex: 1,
                data: [
                    2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
                ]
                },
                {
                name: 'ios',
                type: 'bar',
                yAxisIndex: 2,
                data: [20.0, 20.2, 30.3, 40.5, 60.3, 100.2, 200.3, 230.4, 230.0, 160.5, 120.0, 60.2]
                }
            ]
            };
            this.$nextTick(()=>{
                this.orderChart = this.$echarts.init(this.$refs.order);
                this.orderChart.clear();
                this.orderChart.setOption(option,true);
                this.orderChart.resize();
            })
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000000;'
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }

    .console{
        // padding: 10px;
        .hello{
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            color: #303133;
            display: flex;
            align-items: center;
            min-height: 105px;
            padding: 20px;
            transition: .3s;
            .l{
                width: 60px;
                height: 60px;
                margin-right: 20px;
                border-radius: 50%;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
            }
            .r{
                .t{
                    margin-bottom: 12px;
                    font-size: 20px;
                    font-weight: 700;
                    color: #3c4a54;
                }
                .b{
                    font-size: 14px;
                    color: #808695;
                }
            }
            
        }
        .hello:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
        .echart{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            margin-top: 20px;
            position: relative;
            height: 180px;
            margin-right:10px;
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                border-bottom: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .r{
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    background-color: #e7faf0;
                    border-color: #d0f5e0;
                    color: #13ce66;
                }
                .z{
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    background-color: #fff8e6;
                    border-color: #fff1cc;
                    color: #ffba00;
                }
            }
            .content{
                height: 120px;
                .price{
                    font-size: 30px;
                    padding-left: 15px;
                    padding-top: 10px;
                }
                .progress{
                    padding: 0px 15px;
                    padding-top: 6px;
                }
                .content-data{
                    font-size: 14px;
                    padding: 0px 15px;
                    margin-top: 8px;
                    i{
                        color: #2b60dd;
                    }
                }
            }
            
            .bottom{
                width: 100%;
                position: absolute;
                height: 50px;
                bottom: 0;
                border-top: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                font-size: 14px;
                padding-left: 20px;
            }
            .l{
                display: flex;
                align-items: center;
            }
            .icon-1{
                background-color: #faeebd;
                width: 25px;
                height: 25px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 5px;
                img{
                    width: 15px;
                    height: 15px;
                }
            }
            .user{
                .user-title{
                    display: flex;
                    justify-content: space-around;
                    margin-top: 15px;
                    padding: 0 40px;
                    .user-title-item{
                        width:46px;
                        height:46px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: rgb(214, 240, 255);
                        img{
                            width:36px;
                            height: 36px;
                        }
                    }
                    .user-title-item2{
                        background-color: rgb(253, 240, 255);
                    }
                    .user-title-item3{
                        background-color: rgb(230, 237, 245);
                    }
                }
                .user-content{
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 15px;
                    padding: 0 40px;
                    .user-citem{
                        width: 4%;
                        height: 24px;
                    }
                    .user-citem-m{
                        border-radius: 3px;
                        margin: 2px;
                        width: 90%;
                        height: 90%;
                        background-color: rgba(51, 153, 255,.75);
                    }
                    .user-citem-w{
                        border-radius: 3px;
                        margin: 2px;
                        width: 90%;
                        height: 90%;
                        background-color: rgba(190, 107, 224,.75);
                    }
                    .user-citem-u{
                        border-radius: 3px;
                        margin: 2px;
                        width: 90%;
                        height: 90%;
                        background-color: rgba(186, 189, 195,.75);
                    }
                }
            }
        }
        .echart-user{
            height: 240px;
        }
        .echart:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
        .tag{
            margin-right: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 15px;
            padding-bottom: 18px;
            border-radius: 4px;
            font-size: 15px;
            transition: .3s;
            border: 1px solid #ebeef5;
            background-color: #ffffff;
            cursor: pointer;
            img{
                width: 28px;
                height: 28px;
                margin-top: 18px;
                margin-bottom: 6px;
            }
        }
        .tag:hover{
            box-shadow: 0 2px 12px 0px rgba(163, 163, 163, 0.363);
        }
        .table{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            min-height: 268px;
            margin-top: 20px;
            ::v-deep .el-table th{
                padding: 7px 0;
            }
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #ebeef5;
            }
            .content{
                height: 240px;
                padding: 15px;
            }
        }
        .table:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
    }
</style>
